import React from "react";

// Props for the Layout component
interface LayoutMobileProps {
  children: React.ReactNode; // Nested components (e.g., InputGroup, WarningMessage, FindRoutesButton)
  map: React.ReactNode; // MapContainer component
  routes: React.ReactNode; // RouteCard component
}

// Mobile-optimized layout: stacked vertically, compact spacing, larger map
const LayoutMobile: React.FC<LayoutMobileProps> = ({ children, map, routes }) => {
  const version = window.trpSettings?.version;

  return (
    <div className="trp-mobile-container">
      {/* Panel section - inputs and controls */}
      <div className="trp-mobile-panel">
        <h2 className="trp-mobile-title">
          Plan Your Trip
          {version && <span className="trp-mobile-version">v{version}</span>}
        </h2>
        {children}
      </div>

      {/* Map section - taller for mobile viewing */}
      <div className="trp-mobile-map">
        {map}
      </div>

      {/* Routes section */}
      {routes}
    </div>
  );
};

export default LayoutMobile;
